export default __webpack_public_path__ + "static/media/icon3.9ad260cd.svg";